import React, { useEffect, useState, useRef } from "react";
import Card from "Front/components/Card/Card.jsx";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import Switch from "react-bootstrap-switch";
import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css";
import AddEditBillCategoryModal from "./AddEditBillCategory";
import * as API from '../../../api/billing'
import Loading from "react-loading";
import NotificationSystem from "react-notification-system";
import { style } from "Admin/variables/Variables.jsx";
import { FormControl } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "Front/actions/actionTypes";


const BillCategoryList = () => {
    const [openModal, setOpenModal] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({ limit: 10, page: 0, direction: "asc", search: "" });
    const [totalCount, setTotalCount] = useState(0);
    const [scroll, setScroll] = useState(0);
    const notificationSystem = useRef(null);
    const [sortData, setSortData] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const dispatch = useDispatch()
    const billingReduxData = useSelector((store) => store.billing);


    const toggleActive = async (row) => {
        let resp = await API.updateBillCategory({
            id: row._id,
            isActive: !row.isActive,
        });
        if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
            const updated = categoryList.map(item =>
                item._id === row?._id ? { ...item, isActive: !row.isActive } : item
            );
            setCategoryList([...updated]);
            const allCategories = billingReduxData?.BillCategoryList || [];
            const updatedCategories = allCategories.map(cat => {
                if (cat?._id === row?._id) {
                    return {
                        ...cat,
                        isActive: !row.isActive
                    };
                }
                return cat;
            });
            dispatch({
                type: actionTypes.SET_ALL_BILL_CATEGORY_LIST,
                payload: updatedCategories,
            });
            handleToastifyMessage("status", !row.isActive)
        }
    };

    //  const statusChangedHandler = async (row, index) => {
    //     let resp = await API.statusChangeDrug({
    //       id: row._id,
    //       status: row.enabled === "1" ? "0" : "1",
    //     });
    //     if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
    //       handleToastifyMessage("status");
    //       let drug = drugList;
    //       let count = totalCount + 1;
    //       if (row.enabled === "1") {
    //         drug[index].enabled = "0";
    //       } else {
    //         drug[index].enabled = "1";
    //       }
    //       setDrugList(drug);
    //       setTotalCount(count);
    //     }
    //   };

    const srNo = (cell, row, enumObject, rowIndex) => {
        return (rowIndex + 1 + (formData.limit * formData.page))
    }

    const formatSwitch = (cell, row) => (
        <Switch
            onText=""
            offText=""
            value={row.isActive}
            onChange={() => toggleActive(row)}
            bsSize="small"
            onColor="primary"
        />
    );

    const formatEdit = (cell, row, enumObject, index) => {
        return (
            <i
                className="fa fa-pencil"
                style={{ cursor: "pointer" }}
                onClick={() => {
                    setSelectedRow(row);
                }}
            ></i>
        );
    };

    const onHide = (isReloadList = false) => {
        setSelectedRow(null)
        setOpenModal(false)
        if (isReloadList)
            getBillCategoryList(formData)

    }

    const handleAddCategory = () => {
        setOpenModal(true)
    }

    const getBillCategoryList = async (from = {}) => {
        setIsLoading(true);
        setCategoryList([])
        let resp = await API.categoryList({ "limit": from.limit, "offset": from.page, "order": "createdAt", "direction": from.direction, "search": from.search });
        if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
            setIsLoading(false);
            setCategoryList(resp.data.data);
            setTotalCount(resp.data.totalCount);
        }

    }

    const _setTableOption = () => {
        if (isLoading) {
            return (
                <Loading type='bars' color='#000000' style={{ margin: '0px auto', width: "40px" }} />
            );
        } else {
            return "No data found!";
        }
    }

    const rowStyleFormat = (row, rowIdx) => {
        if (row && row.visited) {
            return { backgroundColor: '#f3f1b0' };
        }
    }

    const onPageChange = (page, sizePerPage) => {
        let data = formData;
        data['page'] = page - 1;
        data['limit'] = sizePerPage;
        setFormData({ ...formData, ...data });
        getBillCategoryList(data);

        let scrollBar = 50;
        if (scroll == page && sizePerPage < scrollBar) {
            eval('$(".ps").scrollTop(0)');
        } else if (totalCount < page * sizePerPage) {
            eval('$(".ps").scrollTop(0)');
        }
        setScroll(page)
    }

    function sortHandle() {
        let data = formData;
        data['direction'] = sortData ? "desc" : "asc";
        setFormData({ ...formData, ...data });
        getBillCategoryList(data);
    }

    const options = {
        //onSortChange: this.onSortChange,
        clearSearch: true,
        pageStartIndex: 1, // where to start counting the pages
        paginationSize: 3,  // the pagination bar size.
        prePage: 'Prev', // Previous page button text
        nextPage: 'Next', // Next page button text
        firstPage: 'First', // First page button text
        lastPage: 'Last', // Last page button text
        //paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
        paginationPosition: 'bottom',  // default is bottom, top and both is all available
        sizePerPage: formData.limit,
        onPageChange: onPageChange,
        page: formData.page + 1,
        noDataText: _setTableOption()
    };

    const handleToastifyMessage = (data, status) => {
        let msg = "";
        if (data === "add") msg = "Category Added Successfully";
        if (data === "edit") msg = "Category Edit Successfully";
        if (data === "status") msg = status ? "Category activated Successfully" : "Category deactivated Successfully";
        const notification = notificationSystem.current;
        notification.addNotification({
            title: (
                <span
                    data-notify="icon"
                    className="pe-7s-check"
                    style={{
                        fontSize: "30px",
                        color: "#fff",
                        padding: "0px !important",
                        top: "0% !important",
                    }}
                ></span>
            ),
            message: <div>{msg}</div>,
            level: "success",
            position: "tr",
            autoDismiss: 2,
        });
    };

    const onSearchChange = (e, field = "") => {
        let saveFormData = formData;
        saveFormData[field] = e.trimStart();
        saveFormData["page"] = 0;
        setFormData({ ...formData, ...saveFormData });
        getBillCategoryList(saveFormData);
    };


    useEffect(() => {
        if (selectedRow)
            setOpenModal(true)
    }, [selectedRow])

    useEffect(() => {
        getBillCategoryList(formData)
    }, [])

    return (
        <div className="main-content">
            <div>
                <NotificationSystem ref={notificationSystem} style={style} />
            </div>
            <div className="row align-items-center mb-4">
                <div className="col-md-4">
                    <FormControl
                        type="text"
                        autocomplete="off"
                        name="search"
                        id="search"
                        value={formData.search ? formData.search : ""}
                        onChange={(e) => {
                            onSearchChange(e.target.value.replace(/\s+/g, " "), "search");
                        }}
                        placeholder="Search here ..."
                    />
                </div>
                <div className="col-md-4 d-flex justify-content-center">
                    <h5 className="mb-0" style={{ textAlign: "end", fontWeight: "bold" }}>Categories</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end gap-2">
                    <button
                        className="btn btn-outline-primary rounded-pill px-3 d-flex align-items-center"
                        style={{ backgroundColor: "#0047AB", color: "#fff", position: "absolute", right: "18px" }}
                        onClick={() => handleAddCategory()}
                    >
                        <i className="fa fa-plus" style={{ marginRight: "6px" }}></i>
                        Add Category
                    </button>
                </div>
            </div>

            <Card
                className="mt-2"
                content={
                    <div className="fresh-datatables switch-btn-style">
                        <BootstrapTable
                            deleteRow={false}
                            key={categoryList}
                            data={categoryList}
                            search={false}
                            multiColumnSearch={true}
                            pagination={true}
                            options={options}
                            striped
                            hover
                            condensed
                            scrollTop={"Bottom"}
                            remote={true}
                            fetchInfo={{ dataTotalSize: totalCount }}
                            trStyle={rowStyleFormat}
                        >
                            <TableHeaderColumn
                                hidden={true}
                                tdAttr={{ "data-attr": "_id" }}
                                dataField="_id"
                                isKey
                                searchable={false}
                            >
                                Id
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "#" }}
                                thStyle={{ width: "5%", textAlign: "center" }}
                                tdStyle={{ width: "5%", textAlign: "center" }}
                                dataField="sn"
                                dataFormat={srNo}
                            >
                                S.No.
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "#" }}
                                thStyle={{ width: "25%", textAlign: "center" }}
                                tdStyle={{ width: "25%", textAlign: "center" }}
                                dataField="name"
                            >
                                S.No.
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "30%", textAlign: "center" }}
                                tdStyle={{ width: "30%", textAlign: "center" }}
                                dataField="description"
                            >
                                Description
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                dataFormat={formatSwitch}
                                dataAlign="center"
                                width="15%"
                            >
                                Active/Deactivate
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                dataFormat={formatEdit}
                                dataAlign="center"
                                width="15%"
                            >
                                Edit
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                }
            />
            {openModal &&
                <AddEditBillCategoryModal
                    show={openModal}
                    onHide={onHide}
                    row={selectedRow}
                    isCategoryAddedFromAddOnService={false}
                />
            }
        </div>
    );
};

export default BillCategoryList;
